  document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("scroll", function () {
      document.querySelectorAll(".wow").forEach(function (element) {
        var imgPos = element.getBoundingClientRect().top + window.pageYOffset;
        var scroll = window.pageYOffset;
        var windowHeight = window.innerHeight;
        if (scroll > imgPos - windowHeight + windowHeight / 2) {
          element.classList.add("animated");
        }
      });
    });
  });


  const michael = document.querySelector(".michael");

  // 移動処理の本体
  function handleScroll() {
    const currentScrollY = window.scrollY;
    const windowWidth = window.innerWidth;

    const maxDistance = windowWidth - michael.offsetWidth;
    const moveX = (currentScrollY % (maxDistance * 2));
    const finalX = moveX > maxDistance ? (maxDistance * 2 - moveX) : moveX;

    // 今回は「実際の移動方向で反転する」例
    const scaleX = finalX >= (handleScroll.previousX || 0) ? 1 : -1;
    handleScroll.previousX = finalX;

    michael.style.transform = `translateX(${finalX}px) scaleX(${scaleX})`;

    // scrollingクラスの付け外し（スクロールが止まった時）
    clearTimeout(handleScroll.scrollTimeout);
    handleScroll.scrollTimeout = setTimeout(() => {
      michael.classList.remove("scrolling");
    }, 150);

    // scrollingクラスを常にONに（タイマーでOFFにするので）
    michael.classList.add("scrolling");
  }

  // scrollイベントの有効・無効を切り替えるためのフラグ
  let scrollEnabled = false;

  // イベントをONにする関数
  function enableScrollAnimation() {
    if (!scrollEnabled) {
      window.addEventListener("scroll", handleScroll);
      scrollEnabled = true;
    }
  }

  // イベントをOFFにする関数
  function disableScrollAnimation() {
    if (scrollEnabled) {
      window.removeEventListener("scroll", handleScroll);
      scrollEnabled = false;
      // ついでにキャラクターのtransformをリセットするなど
      michael.style.transform = "";
      michael.classList.remove("scrolling");
    }
  }

  // 画面幅をチェックしてON/OFFを切り替える
  function checkWidthAndToggleAnimation() {
    if (window.innerWidth <= 768) {
      enableScrollAnimation();
    } else {
      disableScrollAnimation();
    }
  }

  // 初期化: ページロード時に1回実行
  checkWidthAndToggleAnimation();

  // リサイズ時にも呼び出して状況に合わせる
  window.addEventListener("resize", checkWidthAndToggleAnimation);
    